import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { lengthValidation250, required } from '../Forms/utils';
import { formatRecipients } from './utils';

import { secondaryColor } from '../../theme';
import { REACT_SELECT_INPUT, STYLED_TEXT } from '../Forms/fieldTypes';

const RejectVisitor = ({
  residents,
  staff,
  building,
  selectedCameraId,
  form,
  onSubmit,
  onModalClose,
  isFrontDesk,
}) => {
  const residentsAndStaff = [].concat(residents, staff);
  const formData = [
    {
      keyName: 'comment',
      label: 'Visitor name and other details',
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [required, lengthValidation250],
    },
    {
      keyName: 'recipient',
      label: 'Host',
      fieldType: REACT_SELECT_INPUT,
      options: formatRecipients(residentsAndStaff, true, isFrontDesk),
      placeholder: isFrontDesk ? 'Select host' : 'Filter by name, unit or role',
      validate: [required],
    },
  ];

  const customSubmitStyle = {
    backgroundColor: secondaryColor,
  };

  if (isFrontDesk) {
    customSubmitStyle.width = 'fit-content';
    customSubmitStyle.marginLeft = 'auto';
  }

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      title="Reject Visitor"
      submitText="Reject visitor and notify host"
      customSubmitStyle={customSubmitStyle}
      isUpdate={false}
      canBeUpdated={false}
      backButton={false}
      isFullWidthForm
      isFullWidthSubmit
      building={building}
      selectedCameraId={selectedCameraId}
      onModalClose={onModalClose}
    />
  );
};

RejectVisitor.defaultProps = {
  onSubmit: () => {},
  onModalClose: () => {},
  building: {},
  selectedCameraId: null,
};

RejectVisitor.propTypes = {
  residents: PropTypes.instanceOf(Array).isRequired,
  staff: PropTypes.instanceOf(Array).isRequired,
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  building: PropTypes.instanceOf(Object),
  selectedCameraId: PropTypes.number,
  onModalClose: PropTypes.func,
  isFrontDesk: PropTypes.bool,
};

export default RejectVisitor;
